import * as React from "react";
import { SVGProps } from "react";

const Parsiq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 46 46"
    {...props}
  >
    <style>{".st0{fill:#005cc7}"}</style>
    <path
      id="Path"
      d="M9.9 31.8v5.1H15v-1.3h7.1v11.3C10.3 46.2.6 36.5 0 24.7h11.3v7l-1.4.1z"
      className="st0"
    />
    <path
      id="Path_1_"
      d="M31.7 35.6v1.3h5.1v-5.1h-1.3v-7h11.3c-.6 11.8-10.4 21.4-22.2 22.1V35.6h7.1z"
      className="st0"
    />
    <path
      id="Path_2_"
      d="M22.1 11.5h9.7V10H37v5.7h-5.1v-1.6h-9.7v10.6l11 .1v7h-1.3V33H15v-1.3h-1.2V15.1h1.3V10H10v5.1h1.3v7H0C.6 10.2 10.4.6 22.1 0v11.5z"
      className="st0"
    />
  </svg>
);

export default Parsiq;
